export const textPrimary = 'text-primary-700 dark:text-primary-300';
export const textBlue = `text-blue-600 dark:text-blue-400`; // #0069cc dark:#60a5fa
export const textDarkBlue = `text-blue-700 dark:text-blue-500`; // #1447e6 dark:#2b7fff
export const textDarkestBlue = `text-darkest-blue-500 dark:text-darkest-blue-500`; // #00315D
export const textYellow = `text-yellow-400 dark:text-yellow-200`; // #facc15 dark:#fef08a
export const textTeal = `text-teal-600 dark:text-teal-400`; // #0d9488 dark:#2dd4bf
export const textOlive = `text-olive-600 dark:text-olive-300`; // #65a30d dark:#bef264
export const textGreen = `text-green-700 dark:text-green-400`; // #15803d dark:#4ade80
export const textOrange = `text-orange-600 dark:text-orange-300`; //#ea580c dark:#fdba74
export const textRed = `text-red-500 dark:text-red-300`; // #ef4444 dark:#fca5a5
export const textPink = `text-pink-600 dark:text-pink-300`; // #db2777 dark:#f9a8d4
export const textPink700 = `text-pink-700 dark:text-pink-200`; // #be185d dark:#fbcfe8
export const textLavender = `text-lavender-600 dark:text-lavender-400`; // #7c3aed dark:#a78bfa
export const textPurple = `text-purple-500 dark:text-purple-300`; // #a855f7 dark:#d8b4fe
export const textCyan = `text-cyan-700 dark:text-cyan-300`; // #0891b2 dark:#64d5ca
export const textEmerald = `text-emerald-700 dark:text-emerald-400`; // #10b981 dark:#34d399

export const textOrange700 = `text-orange-700 dark:text-orange-200`; // #c2410c dark: #fed7aa
export const textTeal700 = `text-teal-700 dark:text-teal-200`; // #0f766e dark: #99f6e4

export const textGray = `text-gray-900 dark:text-gray-100`; // #111827 dark: #f3f4f6
export const textGrayInvert = `text-white dark:text-gray-800`; // #fff dark: #1f2937

export const textNeutral700 = `text-neutral-700 dark:text-neutral-300`; // #404040 dark: #d4d4d4
export const textNeutral600 = `text-neutral-600 dark:text-neutral-400`; // #525252 dark: #a3a3a3

export const textSlate900 = 'text-slate-900 dark:text-slate-100'; // #111827 dark: #f3f4f6

export const textGray900 = `text-gray-800 dark:text-gray-50`; // #1f2937 dark:#f9fafb
export const textGray800 = `text-gray-700 dark:text-gray-100`; // #374151 dark:#f3f4f6
export const textGray780 = 'text-gray-680 dark:text-gray-200'; // #444444 dark:#e5e7eb
export const textGray700 = 'text-gray-600 dark:text-gray-200'; // #4b5563 dark:#e5e7eb
export const textGray600 = 'text-gray-500 dark:text-gray-300'; // #6b7280 dark:#d1d5db
export const textGray500 = 'text-gray-400 dark:text-gray-400'; // #9ca3af dark:#9ca3af
export const textGray400 = 'text-gray-300 dark:text-gray-500'; // #d1d5db dark:#6b7280
export const textGray350 = 'text-gray-350 dark:text-gray-600'; // #c4c4c4 dark:#4b5563
export const textGray300 = 'text-gray-200 dark:text-gray-600'; // #e5e7eb dark:#4b5563
export const textGray200 = `text-gray-100 dark:text-gray-700`; // #f3f4f6 dark:#374151
export const textGray100 = `text-gray-50 dark:text-gray-800`; // #f9fafb dark:#1f2937
export const textGray20 = `text-gray-20 dark:text-gray-800`; // #ebebeb dark:#1f2937

export const textWarningText = `text-warningText-light dark:text-warningText-dark`; // #c2410c dark: #fdba74
export const textPositiveText = `text-positiveText-light dark:text-positiveText-dark`; // #15803d dark: #86efac
export const textNegativeText = `text-negativeText-light dark:text-negativeText-dark`; // #b91c1c dark: #fca5a5

export const text5 = 'text-black'; // #000000
export const text4 = 'text-neutral-700'; // #404040
export const text3 = 'text-neutral-500'; // #737373
export const text2 = 'text-neutral-300'; // #d4d4d4
export const text1 = 'text-zinc-100'; // #f4f4f5
export const text0 = 'text-white'; // #ffffff

export const textLightGrayDarkGray = 'text-gray-300 dark:text-gray-600'; // #d1d5db dark: #4b5563
export const textWhiteBlack = 'text-white dark:text-black'; // #ffffff dark: #000000

export const textBagLightBlue =
  'text-bag-light-blue-500 dark:text-bag-light-blue-500'; // #FAFDFF
export const textLightestBlue = 'text-light-blue-500 dark:text-light-blue-500'; // #F4F9FF

// composer themes
export const textColorClassMap: { [key: string]: string } = {
  textInvert: 'text-white',
  text: textGray,
  primaryText: textPrimary,
  primaryLightest: textBlue,
  white: ``,
  textLightestBlue: text5,
  transparentWhiteText: `${text0} py-[6px] px-[8px] text-base	font-normal`,
};
